import type { Catalog } from '@/types';

/**
 * 兌換點數 → 「約可再生成幾張圖片」的換算(R276;Bryan 拍板)
 * -----------------------------------------------------------------------------
 * R164/R198 起全站不顯示點數數字,兌換成功畫面也一樣 —— 但使用者得知道這張序號
 * 換到了「多少」。拍板的答案是換算成**圖片張數**(大家都懂的單位),而不是點數。
 *
 * 分母 = catalog `tools.IMAGE` 的**預設 model per-step 點數**(`ModelOption.credits`,
 * BE 真值)。⚠️ 判準三條:
 *   1. **不硬編任何價格**:R168 已把寫死估價表(IMAGE=5 那張)整個刪掉 —— 價格是 BE
 *      的事,catalog 沒載到就誠實回 null(成功畫面少一行換算,不編一個可能錯的數字)。
 *   2. 取 `default: true` 的 model(每個 tool 恰一個;catalog 契約),沒有 default
 *      再退第一個 —— 與生成時 user 不動下拉的實際扣點同源。
 *   3. `floor`:「約可生成 3 張」代表點數**夠**生 3 張;無條件進位會承諾生不出來的那張。
 *
 * 這是**估算**(文案帶「約」):實際扣點依生成當下的設定(模型 / 比例張數)而定。
 */
export function estimateImageCount(catalog: Catalog | null, credits: number): number | null {
  if (!catalog || !Number.isFinite(credits) || credits <= 0) return null;
  const image = catalog.tools['IMAGE'];
  if (!image || image.models.length === 0) return null;
  const model = image.models.find((m) => m.default) ?? image.models[0];
  const per = model.credits;
  if (!Number.isFinite(per) || per <= 0) return null;
  return Math.floor(credits / per);
}
